export default {
  FOOTER: [
    {
      links: [
        {
          name: 'Цифры и факты',
          link: 'https://www.hse.ru/figures/'
        },
        {
          name: 'Руководство и структура',
          link: 'https://www.hse.ru/orgstructure/'
        },
        {
          name: 'Преподаватели и сотрудники',
          link: 'https://www.hse.ru/org/persons/'
        },
        {
          name: 'Корпуса и общежития',
          link: 'https://www.hse.ru/buildinghse'
        },
        {
          name: 'Закупки',
          link: 'https://www.hse.ru/org/hse/aup/procurement/'
        },
        {
          name: 'Обращения граждан в НИУ ВШЭ',
          link: 'https://www.hse.ru/appeal/'
        },
        {
          name: 'Фонд целевого капитала',
          link: 'https:/endowment.hse.ru/'
        },
        {
          name: 'Противодействие коррупции',
          link: 'https://www.hse.ru/anticorruption'
        },
        {
          name: 'Сведения о доходах, расходах, об имуществе и обязательствах имущественного характера',
          link: 'https://www.hse.ru/anticorruption/information'
        },
        {
          name: 'Сведения об образовательной организации ВШЭ',
          link: 'https://www.hse.ru/sveden/'
        },
        {
          name: 'ВШЭ для людей с ограниченными возможностями здоровья и инвалидов',
          link: 'https://inclusive.hse.ru/'
        },
        {
          name: 'Единая платежная страница',
          link: 'https://pay.hse.ru/'
        }
      ],
      name: 'о вышке'
    },
    {
      links: [{
        name: 'Лицей',
        link: 'https://school.hse.ru'
      },
        {
          name: 'Довузовская подготовка',
          link: 'https://fdp.hse.ru/'
        },
        {
          name: 'Олимпиады',
          link: 'https://olymp.hse.ru/'
        },
        {
          name: 'Прием в бакалавриат',
          link: 'https://ba.hse.ru/'
        },
        {
          name: 'Вышка+',
          link: 'https://www.hse.ru/plus'
        },
        {
          name: 'Прием в магистратуру',
          link: 'https://ma.hse.ru/'
        },
        {
          name: 'Аспирантура',
          link: 'https://aspirantura.hse.ru/'
        },
        {
          name: 'Дополнительное образование',
          link: 'https://busedu.hse.ru/'
        },
        {
          name: 'Корпоративное обучение',
          link: '/#'
        },
        {
          name: 'Центр развития карьеры',
          link: 'https://career.hse.ru/'
        },
        {
          name: 'Карьерные карты',
          link: '/#'
        }
      ],
      name: 'Образование'
    },
    {
      links: [{
        name: 'Научные подразделения',
        link: 'https://www.hse.ru/science/centers'
      },
        {
          name: 'Исследовательские проекты',
          link: 'https://www.hse.ru/org/projects/'
        },
        {
          name: 'Мониторинги',
          link: 'https://www.hse.ru/monitoring/'
        },
        {
          name: 'Научные мероприятия',
          link: '/#'
        },
        {
          name: 'Диссертационные советы',
          link: 'https://www.hse.ru/science/disscoun/'
        },
        {
          name: 'Защиты диссертаций',
          link: 'https://www.hse.ru/science/disscoun/'
        },
        {
          name: 'Академическое развитие',
          link: 'https://academics.hse.ru/'
        },
        {
          name: 'Конкурсы и гранты',
          link: 'https://www.hse.ru/science/hsegrants'
        },
        {
          name: 'Научно-образовательный портал IQ.hse.ru',
          link: 'https://iq.hse.ru/'
        },
      ],
      name: 'наука'
    },
    {
      links: [
        {
          name: 'Библиотека',
          link: 'https://library.hse.ru/'
        },
        {
          name: 'Издательский дом ВШЭ',
          link: 'https://id.hse.ru'
        },
        {
          name: 'Книжный интернет-магазин',
          link: '/#'
        },
        {
          name: 'Книжный магазин «БукВышка»',
          link: 'https://bookshop.hse.ru/'
        },
        {
          name: 'Типография',
          link: 'https://print.hse.ru/'
        },
        {
          name: 'Медиацентр',
          link: 'https://mc.hse.ru/'
        },
        {
          name: 'Журналы ВШЭ',
          link: 'https://www.hse.ru/science/journals'
        },
        {
          name: 'Публикации',
          link: 'https://publications.hse.ru'
        },
        {
          name: 'Единый архив экономических и социологических данных',
          link: 'http://sophist.hse.ru/'
        },
        {
          name: 'Университет, открытый городу',
          link: '/#'
        },
        {
          name: 'Магазин HSE STORE',
          link: '/#'
        },
      ],
      name: 'Ресурсы'
    },
  ],
  HEADER: [
    // {
    //   title: 'Главная',
    //   icon: 'House.svg',
    //   link: '/cabinet'
    // },
    /*
    {
      title: 'Заявка',
      icon: 'list.svg',
      link: '/'
    },*/
    // {
    //   title: 'Мои заявления',
    //   icon: 'icon-note-pencil.svg',
    //   link: '/cabinet/', // link: '/cabinet/application/',
    // },
    /*
    {
      title: 'Вопрос ответ',
      icon: 'ChatsTeardrop.svg',
      link: '/'
    },
    {
      title: 'Документы',
      icon: 'File.svg',
      link: '/'
    },*/
    // {
    //   title: 'Вступительные испытания',
    //   icon: 'icon-student.svg',
    //   link: '/cabinet/tests'
    // },
    // {
    //   title: 'Мои договоры',
    //   icon: 'Briefcase.svg',
    //   // link: '/cabinet/startContracts'
    //   link: '/contracts'
    // },
    // {
    //   title: 'Проживание',
    //   icon: 'icon-buildings.svg',
    //   link: '/residence'
    // },
    // {
    //   title: 'Признание',
    //   icon: 'Medal.svg',
    //   link: '/cabinet/recognition'
    // },
    // {
    //   title: 'Вопрос ответ',
    //   icon: 'ChatsTeardrop.svg',
    //   link: '/cabinet#FAQ'
    // },
  ],
  MOBILEHEADER: [
    // {
    //   title: 'Мои заявления',
    //   icon: 'IconNotePencil',
    //   link: '/cabinet/',
    // },
    // {
    //   title: 'Вступительные испытания',
    //   icon: 'IconStudent',
    //   link: '/cabinet/tests'
    // },
    // {
    //   title: 'Мои договоры',
    //   icon: 'IconBriefcase',
    //   link: '/contracts'
    // },
    // {
    //   title: 'Проживание',
    //   icon: 'IconBuildings',
    //   link: '/residence'
    // },
    // {
    //   title: 'Вопрос ответ',
    //   icon: 'IconChatsTeardrop',
    //   link: '/cabinet#FAQ'
    // }    
  ]
};
